module.exports = __webpack_public_path__ + "img/light-star.2c5498cc.svg";